import {IconProps} from "../Icon";
import {GridInterface, GridOfOptions} from "../components/GridOfOptions";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {motion} from "framer-motion";
import navigationEffect from "../animations/navigationEffect";
import {Issue} from "../components/Issue";
import {extractNumbers, applyReplacements} from "../components/Replacements";

export interface CategoryInterface {
    title: string;
    tag: string;
    icon: IconProps['iconName'];
    subs: string[];
}

export interface CategoryProps {
    allOptions: CategoryInterface[];
}

export const Category = ({allOptions}: CategoryProps) => {
    const [options, setOptions] = useState<GridInterface[]>([]);
    const [title, setTitle] = useState<string>("Избери");
    const {category} = useParams();
    const navigate = useNavigate();


    useEffect(() => {
        const index = allOptions.findIndex((option) => option.tag === category)
        if (index < 0) navigate('/')
        else {
            const list: GridInterface[] = allOptions[index].subs.map((sub) => {
                const title = applyReplacements(sub);
                const justTheNumber = extractNumbers(sub);
                return {
                    title: title,
                    tag: sub,
                    icon: justTheNumber,
                }
            });
            setOptions(list);
            setTitle(allOptions[index].title)
        }
    }, [category, allOptions, navigate]);

    if (options.length === 0) return (<Issue/>)

    return (

        <motion.div {...navigationEffect} className="text-center">
            <h1 className="w-100 mb-5">{title} за кои клас?</h1>
            <GridOfOptions
                options={options}
            />
        </motion.div>
    );
};